import { domReady } from '@/utils/dom-ready'

domReady(() => {
  const statusData = document.getElementById('renewal-status-data')

  if (!statusData) return

  const statusUrl = statusData.getAttribute('data-status-url')
  const manageUrl = statusData.getAttribute('data-manage-url')

  const poll = setInterval(() => {
    fetch(statusUrl)
      .then(r => r.json())
      .then(data => {
        if (data.status === 'done') {
          clearInterval(poll)
          document.getElementById('renewal-progress').classList.add('d-none')
          const success = document.getElementById('renewal-success')
          success.classList.remove('d-none')
          if (manageUrl) {
            document.getElementById('renewal-manage-link').href = manageUrl
          }
        }
      })
  }, 2000)
})
